
import { CustomerShareIndicador, customerShareIndicadorOtimo, customerShareIndicadorBom, customerShareIndicadorRazoavel, customerShareIndicadorRuim } from './indicador';
import { toFixed } from '../../../core/services/utils/numbers';

export class CustomerShareValueObject {
    // Configs
    private _customerShareOtimo: number;
    private _customerShareBom: number;
    private _customerShareRazoavel: number;
    // Potencial (Sell In)
    private _valorPotencial: number;
    // Pretendido
    private _valorPretendido: number;
    private _valorPretendidoPerc: number;
    private _indicadorPretendido: CustomerShareIndicador;
    // Realizado
    private _valorRealizado: number;
    private _valorRealizadoPerc: number;
    private _indicadorRealizado: CustomerShareIndicador;

    constructor(customerShareOtimo: number, customerShareBom: number, customerShareRazoavel: number, valorPotencial: number, valorPretendido: number, valorRealizado: number) {
        // Configs
        this._customerShareOtimo = customerShareOtimo;
        this._customerShareBom = customerShareBom;
        this._customerShareRazoavel = customerShareRazoavel;
        // Potencial (Sell In)
        this._valorPotencial = valorPotencial && !isNaN(valorPotencial) ? Number(valorPotencial) : 0;
        // Pretendido
        this._valorPretendido = valorPretendido && !isNaN(valorPretendido) ? Number(valorPretendido) : 0;
        // Realizado
        this._valorRealizado = valorRealizado && !isNaN(valorRealizado) ? Number(valorRealizado) : 0;

        // Calculando Customer Share Pretendido
        this.calcularPretendido();
        // Calculando Customer Share Realizado
        this.calcularRealizado();
    }

    /** Percentual de valor pretendido */
    get valorPretendidoPerc(): number {
        return this._valorPretendidoPerc;
    }

    /** Indicador do Customer Share Pretendido */
    get indicadorPretendido(): CustomerShareIndicador {
        return this._indicadorPretendido;
    }

    /** Percentual de valor realizado */
    get valorRealizadoPerc(): number {
        return this._valorRealizadoPerc;
    }

    /** Indicador do Customer Share Realizado */
    get indicadorRealizado(): CustomerShareIndicador {
        return this._indicadorRealizado;
    }

    /* obtem o indicador do Customer Share através do percentual informado */
    private getIndicador(perc: number): CustomerShareIndicador {
        // Ótimo
        if (perc >= this._customerShareOtimo) {
            return customerShareIndicadorOtimo;
        }

        // Bom
        if (perc >= this._customerShareBom) {
            return customerShareIndicadorBom;
        }

        // Razoável
        if (perc >= this._customerShareRazoavel) {
            return customerShareIndicadorRazoavel;
        }

        // Ruim
        return customerShareIndicadorRuim;
    }

    /** Cacula o Customer Share pretendido */
    private calcularPretendido() {
        if (this._valorPotencial == 0) {
            this._valorPretendidoPerc = 0;
            this._indicadorPretendido = customerShareIndicadorRuim;
            return;
        }

        // Calcular o percentual pretendido
        const perc = (this._valorPretendido / this._valorPotencial) * 100;
        this._valorPretendidoPerc = toFixed(perc, 2);

        // Obtendo o indicador do customer share pretendido
        this._indicadorPretendido = this.getIndicador(this._valorPretendidoPerc);
    }

    /** Cacula o Customer Share realizado */
    private calcularRealizado() {
        if (this._valorPotencial == 0) {
            this._valorRealizadoPerc = 0;
            this._indicadorRealizado = customerShareIndicadorRuim;
            return;
        }

        // Calcular o percentual realizado
        const perc = (this._valorRealizado / this._valorPotencial) * 100;
        this._valorRealizadoPerc = toFixed(perc, 2);

        // Obtendo o indicador do customer share realizado
        this._indicadorRealizado = this.getIndicador(this._valorRealizadoPerc);
    }
}

